import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import LoadingState from '../components/LoadingState';
import ErrorState from '../components/ErrorState';
import { content as contentApi } from '../../services/apiClient';

const DEFAULT_ADMIN_THEME = {
  palette: {
    background: '#0B0B0F',
    surface: '#12121A',
    border: '#1F1F2A',
    text: '#FFFFFF',
    muted: '#B8B8C5',
    accent: '#FF6A00'
  }
};

export default function AdminAppearance() {
  const [theme, setTheme] = useState(DEFAULT_ADMIN_THEME);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const data = await contentApi.getAdminTheme();
        if (mounted) {
          setTheme({
            ...DEFAULT_ADMIN_THEME,
            ...data,
            palette: { ...DEFAULT_ADMIN_THEME.palette, ...(data?.palette || {}) }
          });
        }
      } catch {
        if (mounted) setError('Erro ao carregar o tema do admin');
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, []);

  const handleSave = async () => {
    await contentApi.updateAdminTheme(theme);
    window.dispatchEvent(new CustomEvent('admin-theme-updated', { detail: theme }));
    alert('Tema do admin atualizado');
  };

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} />;

  return (
    <div className="admin-section">
      <PageHeader title="Aparencia do Admin" subtitle="Personalize cores do painel administrativo" />

      <div className="admin-card">
        <h3>Cores principais</h3>
        <div className="admin-filters">
          <label style={{ color: '#B8B8C5' }}>Fundo</label>
          <input type="color" value={theme.palette.background} onChange={(e) => setTheme({ ...theme, palette: { ...theme.palette, background: e.target.value } })} />
          <label style={{ color: '#B8B8C5' }}>Superficie (cards)</label>
          <input type="color" value={theme.palette.surface} onChange={(e) => setTheme({ ...theme, palette: { ...theme.palette, surface: e.target.value } })} />
          <label style={{ color: '#B8B8C5' }}>Bordas</label>
          <input type="color" value={theme.palette.border} onChange={(e) => setTheme({ ...theme, palette: { ...theme.palette, border: e.target.value } })} />
        </div>
      </div>

      <div className="admin-card">
        <h3>Tipografia e destaque</h3>
        <div className="admin-filters">
          <label style={{ color: '#B8B8C5' }}>Texto principal</label>
          <input type="color" value={theme.palette.text} onChange={(e) => setTheme({ ...theme, palette: { ...theme.palette, text: e.target.value } })} />
          <label style={{ color: '#B8B8C5' }}>Texto secundario</label>
          <input type="color" value={theme.palette.muted} onChange={(e) => setTheme({ ...theme, palette: { ...theme.palette, muted: e.target.value } })} />
          <label style={{ color: '#B8B8C5' }}>Cor de destaque (botoes)</label>
          <input type="color" value={theme.palette.accent} onChange={(e) => setTheme({ ...theme, palette: { ...theme.palette, accent: e.target.value } })} />
        </div>
        <button className="admin-button" style={{ marginTop: 12 }} onClick={handleSave}>Salvar tema do admin</button>
      </div>
    </div>
  );
}
